import { makeRequest, CommonRequestOptions } from '../makeRequest';
import { IndividualSummaryDetailCourse } from './get-course-assignment-individual-summary-details';

export type IndividualCourseStageSummaryDetails = {
   completedCourses: IndividualSummaryDetailCourse[];
   urgentCourses: IndividualSummaryDetailCourse[];
   incompleteCourses: IndividualSummaryDetailCourse[];
};

export async function getCourseAssignmentIndividualStageSummaries(
   userid: number,
   common: CommonRequestOptions = {}
): Promise<IndividualCourseStageSummaryDetails> {
   return makeRequest('get', `course_assignments/individualStageSummaries/${userid}`, common);
}
